import { render, staticRenderFns } from "./callRecord.vue?vue&type=template&id=082904bc&"
import script from "./callRecord.vue?vue&type=script&lang=js&"
export * from "./callRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports